/**
 * The domain which is used in shared cookies.
 * Eg. the watchlist cookie.
 *
 * This setting does not apply to the cookie domain set by the auth system (Cognito).
 * If you need to update the cookie domain if Cognito, look for `NEXT_PUBLIC_AUTH_COOKIE_DOMAIN`.
 */
export const DOMAIN_SHARED_COOKIES =
  process.env.NEXT_PUBLIC_DOMAIN_SHARED_COOKIES ?? '.meinschiff.com';

/**
 * Checks if currently in local environment.
 */
export const onLocal = () => process.env.NEXT_PUBLIC_APP_ENV === 'local';

/**
 * Checks if currently in staging environment.
 */
export const onStaging = () => process.env.NEXT_PUBLIC_APP_ENV === 'staging';

/**
 * Checks if currently in production environment.
 */
export const onProd = () => onLocal() === false && onStaging() === false;
